const actionCampgroundSetData = data => ({
  type: 'CAMPGROUND_SET_DATA', payload: data,
})

export { actionCampgroundSetData }
